export const ColorMap = new Map<string, string>([
  ['Archetype', 'rgb(106, 168, 76)'],
  ['Armor', '#81674c'],
  ['Attack', 'rgb(255, 57, 57)'],
  ['Camp', '#d2d50e'],
  ['Career', 'rgb(106, 168, 76)'],
  ['Crafting', '#407647'],
  ['Downtime', '#0ebed5'],
  ['Equipment', '#a776a0'],
  ['Gambit', '#a776a0'],
  ['Maneuver', '#7ac3ff'],
  ['Passive', '#68696a'],
  ['Reaction', '#bbcc6f'],
  ['Skill', '#d99a07'],
  ['Status', 'rgb(90, 90, 143)'],
  ['Wound', 'rgb(146, 5, 5)'],
  ['Trait', 'rgb(106, 168, 76)'],
  ['Travel', '#5cff69'],
  ['Weapon', 'rgb(226, 119, 43)'],
  ['Earth', '#e0c068'],
  ['Flame', '#f08030'],
  ['Metal', '#b8b8d0'],
  ['Water', '#6890f0'],
  ['Wind', '#a890f0'],
  ['Wood', '#6a5003'],
  ['Mutable', '#68696a'],
  ['Elementless', '#68696a'],
  ['Neutral', '#68696a'],
  ['Arena', '#68696a'],
  ['Danger', '#a50000'],
  ['Augment', '#455dad'],
  ['Encounter', '#703d92'],
  ['Stance', 'thistle'],
])
